import { useContext, useEffect } from 'react'
import { ActionsDropdown } from '@Root/components'
import { FormsChromeContext } from '@Root/pages/Home/Forms/chrome'

export const SubmissionDetailHeader = ({ onResync, isResyncing, applicationLink }) => {
  const chrome = useContext(FormsChromeContext)
  const setExtraLinks = chrome?.setExtraLinks
  const resyncLabel = isResyncing ? 'Resyncing...' : 'Resync'
  const actions = [{ name: resyncLabel, handler: onResync, disabled: isResyncing }]

  useEffect(() => {
    if (!setExtraLinks) return undefined

    setExtraLinks(applicationLink ? [{ name: 'Application details', to: applicationLink }] : [])

    return () => setExtraLinks([])
  }, [applicationLink, setExtraLinks])

  if (!chrome) return null

  return <ActionsDropdown actions={actions} clickHandler={name => actions.find(action => action.name === name)?.handler()} style={chrome.styleConfig.actionsDropdown} />
}
